<template>
  <div id="bdMap11">
  </div>
</template>

<script>
import Axios from "@/utils/Axios";
import Bus from "@/utils/bus.js";
import lev1 from '../../../../../assets/home/lev1.png';
import lev2 from '../../../../../assets/home/lev2.png';
import lev3 from '../../../../../assets/home/lev3.png';
import lev4 from '../../../../../assets/home/lev4.png';
import lev5 from '../../../../../assets/home/lev5.png';
import lev6 from '../../../../../assets/home/lev6.png';
export default {
  data() {
    return {
      styleJson1:
        [
          {
        "featureType": "land",
        "elementType": "geometry",
        "stylers": {
          "color": "#041c75ff",
          "visibility": "on"
        }
      }, {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#041c75ff",
          "visibility": "on"
        }
      }, {
        "featureType": "building",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#001066ff",
          "visibility": "on"
        }
      }, {
        "featureType": "building",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#00004dff",
          "visibility": "on"
        }
      }, {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "village",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "town",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "district",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "country",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "city",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "continent",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "poilabel",
        "elementType": "labels",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "poilabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "scenicspotslabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "scenicspotslabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "transportationlabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "transportationlabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "airportlabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "airportlabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#154f9bff",
          "visibility": "on"
        }
      }, {
        "featureType": "road",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#002c73ff",
          "visibility": "on"
        }
      }, {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": {
          "weight": 3
        }
      }, {
        "featureType": "green",
        "elementType": "geometry",
        "stylers": {
          "color": "#104091ff",
          "visibility": "on"
        }
      }, {
        "featureType": "scenicspots",
        "elementType": "geometry",
        "stylers": {
          "color": "#041c75ff",
          "visibility": "on"
        }
      }, {
        "featureType": "scenicspots",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "scenicspots",
        "elementType": "labels.text.stroke",
        "stylers": {
          "weight": 1,
          "color": "#195fa8ff",
          "visibility": "on"
        }
      }, {
        "featureType": "continent",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "country",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "city",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "city",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "scenicspotslabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "airportlabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "transportationlabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "railway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "subway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "highwaysign",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "nationalwaysign",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "nationalwaysign",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "provincialwaysign",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "provincialwaysign",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "tertiarywaysign",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "tertiarywaysign",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "subwaylabel",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "subwaylabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on",
          "weight": 90
        }
      }, {
        "featureType": "road",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "shopping",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "scenicspots",
        "elementType": "labels",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "scenicspotslabel",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "manmade",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "manmade",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "highwaysign",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "water",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#10409100",
          "visibility": "on"
        }
      }, {
        "featureType": "road",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "road",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "road",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "road",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "road",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "road",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "road",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "road",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "road",
        "elementType": "labels.text",
        "stylers": {
          "fontsize": 24
        }
      }, {
        "featureType": "highway",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "highway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#154f9bff",
          "visibility": "on"
        }
      }, {
        "featureType": "highway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#1c4f7eff"
        }
      }, {
        "featureType": "highway",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "highway",
        "elementType": "geometry",
        "stylers": {
          "weight": 3
        }
      }, {
        "featureType": "nationalway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#154f9bff",
          "visibility": "on"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#1c4f7eff"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "nationalway",
        "elementType": "geometry",
        "stylers": {
          "weight": 3
        }
      }, {
        "featureType": "provincialway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#154f9bff",
          "visibility": "on"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#154f9bff",
          "visibility": "on"
        }
      }, {
        "featureType": "arterial",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#154f9bff",
          "visibility": "on"
        }
      }, {
        "featureType": "tertiaryway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#154f9bff",
          "visibility": "on"
        }
      }, {
        "featureType": "fourlevelway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#154f9bff",
          "visibility": "on"
        }
      }, {
        "featureType": "local",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#154f9bff",
          "visibility": "on"
        }
      }, {
        "featureType": "provincialway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#002c73ff",
          "visibility": "on"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#002c73ff",
          "visibility": "on"
        }
      }, {
        "featureType": "arterial",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#002c73ff",
          "visibility": "on"
        }
      }, {
        "featureType": "tertiaryway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#002c73ff",
          "visibility": "on"
        }
      }, {
        "featureType": "fourlevelway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#002c73ff",
          "visibility": "on"
        }
      }, {
        "featureType": "local",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#002c73ff",
          "visibility": "on"
        }
      }, {
        "featureType": "local",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "local",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "fourlevelway",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "tertiaryway",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "arterial",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "provincialway",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "provincialway",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "arterial",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "tertiaryway",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "fourlevelway",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "fourlevelway",
        "elementType": "geometry",
        "stylers": {
          "weight": 1
        }
      }, {
        "featureType": "tertiaryway",
        "elementType": "geometry",
        "stylers": {
          "weight": 1
        }
      }, {
        "featureType": "local",
        "elementType": "geometry",
        "stylers": {
          "weight": 1
        }
      }, {
        "featureType": "provincialway",
        "elementType": "geometry",
        "stylers": {
          "weight": 3
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "geometry",
        "stylers": {
          "weight": 3
        }
      }, {
        "featureType": "arterial",
        "elementType": "geometry",
        "stylers": {
          "weight": 3
        }
      }, {
        "featureType": "highway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "highway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "highway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "highway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "highway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "highway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "highway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "highway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "highway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "highway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "highway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "highway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "nationalway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "nationalway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "nationalway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "nationalway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "provincialway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "8,10",
          "level": "8"
        }
      }, {
        "featureType": "provincialway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "8,10",
          "level": "9"
        }
      }, {
        "featureType": "provincialway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "8,10",
          "level": "8"
        }
      }, {
        "featureType": "provincialway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "8,10",
          "level": "9"
        }
      }, {
        "featureType": "provincialway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "8,10",
          "level": "8"
        }
      }, {
        "featureType": "provincialway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "8,10",
          "level": "9"
        }
      }, {
        "featureType": "cityhighway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "cityhighway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "cityhighway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "cityhighway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "arterial",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "9,9",
          "level": "9"
        }
      }, {
        "featureType": "arterial",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "9,9",
          "level": "9"
        }
      }, {
        "featureType": "arterial",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "9,9",
          "level": "9"
        }
      }],
      BMapGL: null,
      map: null
    }
  },
  components: {
  },
  created() {
  },
  mounted() {
    let that=this
    this.BMapGL = window.BMapGL;
this.getmapfircenter()

    Bus.$on("changeid", (val) => {


      that.getmapcenter(val.deptId)

    });
  },
  methods: {
    getmapcenter(id){
      let that=this
      const param = {
        url: "/dept/center",
        method: "post",
        data: {
          deptId: id,
        },
      };
      Axios.ajax(param).then((res) => {
        if (res.data) {


          var point = new BMapGL.Point(res.data.lng, res.data.lat);

          let zoom=null
          if(res.data.districtLevel=='country'){
            zoom=8
          }else if(res.data.districtLevel=='province'){
            zoom=10
          }else if(res.data.districtLevel=='city'){
            zoom=11
          }else if(res.data.districtLevel=='district'){
            zoom=15
          }else if(res.data.districtLevel=='street'){
            zoom=19
          }

          that.map.setCenter(point); // 设置地图中心点

          that.map.setZoom(zoom); // 设置地图层级
        }

      });
    },
    getmapfircenter(){
      let that=this
      const param = {
        url: "/dept/userCenter",
        method: "post",
        data: {

        },
      };
      Axios.ajax(param).then((res) => {
        if (res.data) {

          this.initMap(res.data);

        }

      });
    },
    initMap (alldata) {
      let that=this
      this.map = new this.BMapGL.Map('bdMap11');    // 创建Map实例
      let zoom=6

      this.map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
      this.map.setHeading(64.5);
      this.map.setTilt(73);
      this.map.setMapStyleV2({styleJson: this.styleJson1});
      this.map.centerAndZoom(new this.BMapGL.Point(alldata.lng,alldata.lat), zoom);  // 初始化地图,设置中心点坐标和地图级别



      this.getpointList()
      // 监听地图层级
      this.map.addEventListener("zoomend", function(e) {
        var ZoomNum = that.map.getZoom();
        setTimeout(function(){

          that.map.clearOverlays();

          if(ZoomNum<13){
            for(let i=0;i<that.staarr.length;i++){
              that.setposition2(that.staarr[i])
            }
          }else{
            for(let i=0;i<that.staarr.length;i++){
              that.setposition(that.staarr[i])

            }
          }
        },500)

      })
    },
    // initMap (alldata){
    //   // let that=this
    //   // // 初始化百度地图
    //   //  this.map = new BMapGL.Map('bdMap11');
    //   //   let zoom=6
    //   // let center=new this.BMapGL.Point(alldata.lng,alldata.lat)
    //   //
    //   // this.map.setMapStyleV2({styleJson: this.styleJson1});
    //   // // this.map.centerAndZoom(new this.BMapGL.Point(alldata.lng,alldata.lat), zoom);  // 初始化地图,设置中心点坐标和地图级别
    //   //
    //   //
    //   // // 初始化 mapvthree 引擎
    //   // const engine = new Engine(this.map);
    //   // engine.map.setCenter(center);
    //   // engine.map.setPitch(80);
    //   //
    //   // // 添加天空
    //   // const sky = engine.add(new EmptySky());
    //   // sky.time = 3600 * 14.5;
    //   //
    //   //
    //   // // 添加其他
    //   // const geometry = new BoxGeometry(100, 100, 100);
    //   // const material = new MeshStandardMaterial({
    //   //   color: 0xff0000,
    //   //   metalness: 0.8,
    //   // });
    //   // const box = new Mesh(geometry, material);
    //   // const position = engine.map.projectPointArr(center);
    //   // box.position.x = position[0];
    //   // box.position.y = position[1];
    //   // engine.add(box);
    //   //
    //   //
    //   //   that.getpointList()
    //   //   // 监听地图层级
    //   //   this.map.addEventListener("zoomend", function(e) {
    //   //     var ZoomNum = that.map.getZoom();
    //   //     setTimeout(function () {
    //   //
    //   //       that.map.clearOverlays();
    //   //
    //   //       if (ZoomNum < 13) {
    //   //         for (let i = 0; i < that.staarr.length; i++) {
    //   //           that.setposition2(that.staarr[i])
    //   //         }
    //   //       } else {
    //   //         for (let i = 0; i < that.staarr.length; i++) {
    //   //           that.setposition(that.staarr[i])
    //   //
    //   //         }
    //   //       }
    //   //     }, 500)
    //   //   });
    //     let zoom=6
    //   let that=this
    //   let center=[Number(alldata.lng), Number(alldata.lat)]
    //
    //   // 初始化百度地图
    //   this.map = new BMapGL.Map('bdMap11');
    //   this.map.centerAndZoom(new BMapGL.Point(center[0], center[1]), 10);
    //   this.map.enableScrollWheelZoom();
    //   this.map.setTilt(60);
    //   // this.map.setMapStyleV2({styleJson: this.styleJson1});
    //
    //   // 初始化 mapvthree 引擎
    //   const engine = new Engine(this.map);
    //   engine.map.setCenter(center);
    //   engine.map.setPitch(80);
    //
    //   // 添加天空
    //   const sky = engine.add(new EmptySky());
    //   sky.time = 3600 * 14.5;
    //
    //   // 添加其他
    //   const geometry = new BoxGeometry(100, 100, 100);
    //   const material = new MeshStandardMaterial({
    //     color: 0xff0000,
    //     metalness: 0.8,
    //   });
    //   const box = new Mesh(geometry, material);
    //   const position = engine.map.projectPointArr(center);
    //   box.position.x = position[0];
    //   box.position.y = position[1];
    //   engine.add(box);
    //     that.getpointList()
    //     // 监听地图层级
    //     this.map.addEventListener("zoomend", function(e) {
    //       var ZoomNum = that.map.getZoom();
    //       setTimeout(function () {
    //
    //         that.map.clearOverlays();
    //
    //         if (ZoomNum < 13) {
    //           for (let i = 0; i < that.staarr.length; i++) {
    //             that.setposition2(that.staarr[i])
    //           }
    //         } else {
    //           for (let i = 0; i < that.staarr.length; i++) {
    //             that.setposition(that.staarr[i])
    //
    //           }
    //         }
    //       }, 500)
    //     })
    //   return engine;
    //
    // },
    setposition(sta){
      let that=this
// 创建图标
      var lev1img = new BMapGL.Icon(lev1, new BMapGL.Size(33, 40));
      var lev2img = new BMapGL.Icon(lev2, new BMapGL.Size(33, 40));
      var lev3img= new BMapGL.Icon(lev3, new BMapGL.Size(33, 40));
      var lev4img = new BMapGL.Icon(lev4, new BMapGL.Size(33, 40));
      var lev5img = new BMapGL.Icon(lev5, new BMapGL.Size(33, 40));
      var lev6img = new BMapGL.Icon(lev6, new BMapGL.Size(33, 40));
// 创建Marker标注
      if(sta.lat && sta.lng) {
        var pt = new BMapGL.Point(sta.lng, sta.lat);
        // 创建文本标注对象
        var opts = {
          position: new BMapGL.Point(sta.lng, sta.lat), // 指定文本标注所在的地理位置
          offset: new BMapGL.Size(10, -40) // 设置文本偏移量
        };
        var label = new BMapGL.Label(sta.deptName, opts);
// 自定义文本标注样式
        label.setStyle({
          color: 'rgb(250,220,20)',
          borderRadius: '5px',
          borderColor: 'rgba(0,0,0,0)',
          padding: '10px',
          fontSize: '12px',
          height: '30px',
          lineHeight: '10px',
          fontFamily: '微软雅黑',
          backgroundColor: "rgba(0,0,0,0)"
        });

        var marker

        let src = ''
        switch (sta.mostSeriousRiskLevel) {
          case 1:
            src = lev1img;
            break;
          case 2:
            src = lev2img;
            break;
          case 3:
            src = lev3img;
            break;
          case 4:
            src = lev4img;
            break;
          case 5:
            src = lev5img;
            break;
          case 6:
            src = lev6img;
            break;
          default:
            src = lev6img;
        }
        marker = new BMapGL.Marker(pt, {
          icon: src,
        });
        this.map.addOverlay(marker);
        this.map.addOverlay(label);
        marker.addEventListener('click', function (data) {

          // that.getstaList(sta.deptId)
          // that.deptName=sta.deptName
          // that.showtc=true
        });
      }
    },
    setposition2(sta){
      let that=this
// 创建图标
      var lev1img = new BMapGL.Icon(lev1, new BMapGL.Size(33, 40));
      var lev2img = new BMapGL.Icon(lev2, new BMapGL.Size(33, 40));
      var lev3img= new BMapGL.Icon(lev3, new BMapGL.Size(33, 40));
      var lev4img = new BMapGL.Icon(lev4, new BMapGL.Size(33, 40));
      var lev5img = new BMapGL.Icon(lev5, new BMapGL.Size(33, 40));
      var lev6img = new BMapGL.Icon(lev6, new BMapGL.Size(33, 40));
// 创建Marker标注
      if(sta.lat && sta.lng) {
        var pt = new BMapGL.Point(sta.lng, sta.lat);
        // 创建文本标注对象
        var opts = {
          position: new BMapGL.Point(sta.lng, sta.lat), // 指定文本标注所在的地理位置
          offset: new BMapGL.Size(10, -40) // 设置文本偏移量
        };


        var marker

        let src=''
        switch(sta.mostSeriousRiskLevel){
          case 1:
            src = lev1img;
            break;
          case 2:
            src = lev2img;
            break;
          case 3:
            src = lev3img;
            break;
          case 4:
            src = lev4img;
            break;
          case 5:
            src = lev5img;
            break;
          case 6:
            src = lev6img;
            break;
          default:
            src = lev6img;
        }
        marker= new BMapGL.Marker(pt, {
          icon: src,
        });
        this.map.addOverlay(marker);
        // this.map.addOverlay(label);
        marker.addEventListener('click', function (data) {

          // that.getstaList(sta.deptId)
          // that.deptName=sta.deptName
          // that.showtc=true
        });
      }

    },
    getpointList(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/bigScreen/regionalPosition";
      param.data={

      }
      Axios.ajax(param).then((res)=>{
        if(res.data){
          this.staarr=res.data

          for(let i=0;i<res.data.length;i++){
            if(res.data[i].lat && res.data[i].lng) {

              if(i==0){

              }
              that.setposition2(res.data[i])
            }

          }
        }

      })
    },
  },
}
</script>

<style lang="scss" scoped>
.bm-view {
  width: 100%;
  height: 100%;
  position: relative;
}

#bdMap11 {
  width: 100%;
  height: calc(100% - 87px);
  top: 87px;
  position: fixed !important;
  z-index: 0;
}
</style>
